<div class="prochain-evenements">
    @for (event of events$ | async; track $index) {
        <app-carte-agenda [evenement]="event"></app-carte-agenda>
    }
</div>